export const propertyData = [
  {
    id: "1",
    aboutProperty: {
      propertyType: "Single-Family",
      PropertyName: "1500 NE 43rd st",
      propertyAddressLine1: "1500 NE 43rd St",
      propertyAddressLine2: "",
      propertyCity: "Oklahoma City",
      propertyState: "OK",
      propertyPostalCode: "73111",
      propertyCounty: "Oklahoma County",
      isAffordable: false,
    },
    vacant:'',
    upcomingActivities: [
      {id:"1",
        dateTime: "01/25/2023 6:10PM",
        activity: "testing",
        assignto: "Aamir Khan",
        activityFrom: "WORKFLOW",
        isCompleted: false,
      },
      {id:"2",
        dateTime: "01/26/2023 7:10PM",
        activity: "testing 1",
        assignto: "Kashif Ali",
        activityFrom: "SECTION 8",
        isCompleted: false,
      },
    ],
    infoProperty: {
      status: "Occupied",
      isRentReady: true,
      readyForShowingOn: "",
      description: "",
      portfolio: "Integrity Oklahoma LLC (Management Company)",
      siteManager: {
        title: "",
        firstName: "Esteban",
        lastName: "Lezcano",
        email: "esteban@integrityokc.com",
      },
      yearBuilt: "",
      managementStartDate: "",
      managementEndDate: "",
      managementEndReason: "",
      taxAuthority:"",
      liabilitytoLandlordInsurance: "On",
      folioGuardPolicyAdditionalInterest: true,
      interestedParty: "Integrity Oklahoma LLC",
      lockbox:'',
      contactEmail:
        "[Default] Rhett Tullis | President | rhett@integrityokc.com",
      tags: [
        "Gas- ONG",
        "Electric - OG&E",
        "Water - OKCU",
        "Trash - OKCU",
        "Tenant pays- All bills",
      ],
    },
    nonRevenueStatus: false,
    rentalInformation: {
      bedrooms: "2",
      bathrooms: "1.0",
      squareFeet: "914.0",
      marketRent: "0.00",
      useMarketRentonAds: true,
      adminFee: "",
      applicationFee: "45.00",
      securityDeposit: "",
      nsfFee: "45.00",
      useCustomInspectionDate: false,
      lastInspectionOn: "",
      rentStatus: "",
      legalRent: "",
      preferentialRent: "",
      utilitiesIncludedInLease: [],
      appliancesIncludedInLease: [],
      additionalLeaseInformation: "",
    },
    amenities: {
      catsAllowed: "",
      DogsAllowed: "",
      amenitiesTags: [],
    },
    currentTenants: {
      tableColumns: [
        {
          title: "Name",
          dataIndex: "name",
          render: (_,record) => <span className="onclick-text">{record.name}</span>,
        },
        {
          title: "Type",
          dataIndex: "type",
        },
        {
          title: "Move In",
          dataIndex: "moveIn",
        },
        {
          title: "Phone",
          dataIndex: "phone",
        },
        {
          title: "Email",
          dataIndex: "email",
        },
      ],
      tableData: [
        {
          key: "1",
          name: "William Sunken",
          type: "Financially Responsible",
          moveIn: "05/29/2020",
          phone: "Home:(580) 278-3511",
          email: "Wsunken@gmail.com",
        },
      ],
      leaseTerms: "Month to Month, beginning 05/29/2020",
      depositsPaid: "725.00 Security Deposit Liability",
    },
    marketingInformation: {
      postedToYourWebsite: false,
      postedToTheInternet: false,
      premiumLeads: false,
      removedFromVacanciesList: false,
      availableOn: "",
      marketingTitle: "",
      marketingDescription:
        "Updated 2 bedroom, 1 bath home with a 1 car garage and a carport! Updates include fresh paint throughout and new wood vinyl plank flooring. This home is on a corner lot with a fenced in yard. Washer, dryer, and refrigerator all included! Close to major highways, the Okc Zoo & Remington Park. Oklahoma City School District. Rent is $725 per month and deposit is $725. Tenant is responsible for utilities and yard maintenance. Pets not accepted. To schedule a showing and apply online, visit integrityokc.com.",
      youTubeVideoURL: "",
    },
    leaseSettings: {
      selectDefaultLeaseGenerationMethod: "AppFolio Lease Templates",
    },
    defaultNewLeaseTemplates: {
      leaseTemplate: "",
      addendaTemplate: "",
      leaseAttachment: "",
    },
    defaultRenewalTemplates: {
      leaseTemplate: "",
      addendaTemplate: "",
      leaseAttachment: "",
    },
    defaultRenewalMonthToMonthTemplates: {
      leaseTemplate: "",
      addendaTemplate: "",
      leaseAttachment: "",
    },
    defaultRenewalSettings: {
      letterTemplate: "",
      ChangeRentBy: "Dollar Amount",
      tableColumns: [
        {
          title: "Term",
          dataIndex: "term",
        },
        {
          title: "Change by $",
          dataIndex: "Changeby",
        },
        {
          title: "Additional Fee",
          dataIndex: "AdditionalFee",
        },
      ],
      tableData: [
        {
          key: "1",
          term: "12 month",
          Changeby: "0.0",
          AdditionalFee: "0.0",
        },
      ],

    },
    ownersAndFinancials: {
      tableColumns: [
        {
          title: "Owner",
          dataIndex: "owner",
        },
        {
          title: "Percent Owned",
          dataIndex: "percentOwned",
        },
        {
          title: "Contract Expiration",
          dataIndex: "contractExpiration",
        },
      ],
      tableData: [
        {
          key: "1",
          owner: "Aspire Premier Properties",
          percentOwned: "100.0",
          contractExpiration: "",
        },
      ],
      ownershipStartDate: "",
      paymentType: "Net Income",
      reserveFunds: "200.00",
      vendor1099Payer: "Use Portfolio (Integrity Oklahoma LLC)",
      fiscalYearEnd: "December",
      basisForOwnerPackets: "Cash",
    },
    managementFees: {
      startDate: "",
      waiveFeesWhenVacant: false,
      feeType: "Percent",
      amount: "",
      minimum: "",
      maximum: "",
      managementFee: "8.5%",
      whenVacant: "Collected",
    },
    additionalFees: {
      leaseFee: {
        LeaseFeeType: "Flat",
        LeaseFlatFee: "200.00",
      },
      renewalFee: {
        renewelFeeType: "Flat",
        renewalFlatFee: "100.00",
      },
      additionalFees: {
        tableColumns: [
          {
            title: "GL Account",
            dataIndex: "glAccount",
          },
          {
            title: "Percentage",
            dataIndex: "percentage",
          },
          {
            title: "Suppress",
            dataIndex: "suppress",
          },
        ],
        tableData: [
          {
            key: "1",
            glAccount: "112: Application Fee Income",
            percentage: "100.0",
            suppress: "Yes",
          },
          {
            key: "2",
            glAccount: "998: tbp	",
            percentage: "100.0",
            suppress: "Yes",
          },
          {
            key: "3",
            glAccount: "997: Eviction Notice Fee	",
            percentage: "100.0",
            suppress: "Yes",
          },
        ],
      },
    },
    lateFeePolicy: {
      baseAmount: "10.0%",
      eligibleCharges: "All",
      calculateFeeFrom: "New Delinquent Charge",
      ignorePartialPayments: "No",
      dailyAmountOrMonthlyMax: "",
      gracePeriod: "Late fees post after 3 days",
      graceBalance: "0.00",
    },
    keys: {
      tableColumns: [
        {
          title: "ID",
          dataIndex: "id",
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Available",
          dataIndex: "available",
        },
        {
          title: "Actions",
          dataIndex: "available",
          fixed: "right",
          render: () => <a>Actions</a>,
        },
      ],
      tableData: [
        {
          id: "1",
          description: "test",
          available: "2/2",
        },
      ],
    },
    maintenanceInformation: {
      maintenanceLimit: "0.00",
      insuranceExpiration: "",
      isCoveredHomeWarranty: false,
      unitEntryPreAuthorized: false,
      maintenanceNotes: "",
      onlineMaintenanceRequestInstructions: "",
    },

    propertyGroups: "test group",
    statementSettings: {
      useEnhancedStatement: true,
      includeCurrentUpcomingCharges: true,
      includeUpcomingChargesInAmountDue: true,
      includeCustomMessage: false,
      includeLogo: false,
      includePaymentDueDate: false,
      chargerHistoryIncludes: "All Past Due Charges",
      includePaymentHistoryAndBalanceForward: false,
      isShowRemainingAmountDueForPastDue: false,
    },
    bankAccounts: {
      tableColumns: [
        {
          title: "Cash GL Account",
          dataIndex: "cashGLAccount",
        },
        {
          title: "Bank Account",
          dataIndex: "bankAccount",
        },
        {
          title: "Payments Enabled",
          dataIndex: "paymentsEnabled",
        },
      ],
      tableData: [
        {
          key: "1",
          cashGLAccount: "23291: Rental Income Account",
          bankAccount: [
            "Rental Income Account (Liberty National Bank)",
            "(Operating Cash Account)",
          ],
          paymentsEnabled: "ENABLED",
        },
      ],
    },
  },

  {
    id: "2",
    aboutProperty: {
      propertyType: "Single-Family",
      PropertyName: "1605 Symphony Lane",
      propertyAddressLine1: "1605 Symphony Lane",
      propertyAddressLine2: "",
      propertyCity: "Midwest City, OK 73130",
      propertyState: "OK",
      propertyPostalCode: "73130",
      propertyCounty: "Oklahoma County",
      isAffordable: false,
    },
    infoProperty: {
        status: "Occupied",
        isRentReady: true,
        readyForShowingOn: "",
        description: "",
        portfolio: "Integrity Oklahoma LLC (Management Company)",
        siteManager: {
          title: "",
          firstName: "Esteban",
          lastName: "Lezcano",
          email: "esteban@integrityokc.com",
        },
        yearBuilt: "",
        managementStartDate: "",
        managementEndDate: "",
        managementEndReason: "",
        taxAuthority:"",
        liabilitytoLandlordInsurance: "On",
        folioGuardPolicyAdditionalInterest: true,
        interestedParty: "Integrity Oklahoma LLC",
        lockbox:'',
        contactEmail:
          "[Default] Rhett Tullis | President | rhett@integrityokc.com",
        tags: [
          "Gas- ONG",
          "Electric - OG&E",
          "Water - OKCU",
          "Trash - OKCU",
          "Tenant pays- All bills",
        ],
      },
    vacant:'Yes',
    upcomingActivities: [
      {
        id:"1",
        dateTime: "01/25/2023 6:10PM",
        activity: "testing",
        assignto: "Aamir Khan",
        activityFrom: "WORKFLOW",
        isCompleted: false,
      },
      {
        id:"2",
        dateTime: "01/26/2023 7:10PM",
        activity: "testing 1",
        assignto: "Kashif Ali",
        activityFrom: "SECTION 8",
        isCompleted: false,
      },
    ],
   
    nonRevenueStatus: "No",
    rentalInformation: {
      bedrooms: "2",
      bathrooms: "1.0",
      squareFeet: "914.0",
      marketRent: "0.00",
      useMarketRentonAds: true,
      adminFee: "",
      applicationFee: "45.00",
      securityDeposit: "",
      nsfFee: "45.00",
      useCustomInspectionDate: false,
      lastInspectionOn: "",
      rentStatus: "",
      legalRent: "",
      preferentialRent: "",
      utilitiesIncludedInLease: [],
      appliancesIncludedInLease: [],
      additionalLeaseInformation: "",
    },
    amenities: {
      catsAllowed: "",
      DogsAllowed: "",
      amenitiesTags: [],
    },
    currentTenants: {
      tableColumns: [
        {
          title: "Name",
          dataIndex: "name",
          render: (_,record) => <span className="onclick-text">{record.name}</span>,

        },
        {
          title: "Type",
          dataIndex: "type",
        },
        {
          title: "Move In",
          dataIndex: "moveIn",
        },
        {
          title: "Phone",
          dataIndex: "phone",
        },
        {
          title: "Email",
          dataIndex: "email",
        },
      ],
      tableData: [
        {
          key: "1",
          name: "William Sunken",
          type: "Financially Responsible",
          moveIn: "05/29/2020",
          phone: "Home:(580) 278-3511",
          email: "Wsunken@gmail.com",
        },
      ],
      leaseTerms: "Month to Month, beginning 05/29/2020",
      depositsPaid: "725.00 Security Deposit Liability",
    },
    marketingInformation: {
      postedToYourWebsite: "No",
      postedToTheInternet: "No",
      premiumLeads: "off",
      removedFromVacanciesList: false,
      availableOn: "",
      marketingTitle: "",
      marketingDescription:
        "Updated 2 bedroom, 1 bath home with a 1 car garage and a carport! Updates include fresh paint throughout and new wood vinyl plank flooring. This home is on a corner lot with a fenced in yard. Washer, dryer, and refrigerator all included! Close to major highways, the Okc Zoo & Remington Park. Oklahoma City School District. Rent is $725 per month and deposit is $725. Tenant is responsible for utilities and yard maintenance. Pets not accepted. To schedule a showing and apply online, visit integrityokc.com.",
      youTubeVideoURL: "",
    },
    leaseSettings: {
      selectDefaultLeaseGenerationMethod: "AppFolio Lease Templates",
    },
    defaultNewLeaseTemplates: {
      leaseTemplate: "",
      addendaTemplate: "",
      leaseAttachment: "",
    },
    defaultRenewalTemplates: {
      leaseTemplate: "",
      addendaTemplate: "",
      leaseAttachment: "",
    },
    defaultRenewalMonthToMonthTemplates: {
      leaseTemplate: "",
      addendaTemplate: "",
      leaseAttachment: "",
    },
    defaultRenewalSettings: {
        letterTemplate: "",
        ChangeRentBy: "Dollar Amount",
        tableColumns: [
          {
            title: "Term",
            dataIndex: "term",
          },
          {
            title: "Change by $",
            dataIndex: "Changeby",
          },
          {
            title: "Additional Fee",
            dataIndex: "AdditionalFee",
          },
        ],
        tableData: [
          {
            key: "1",
            term: "12 month",
            Changeby: "0.0",
            AdditionalFee: "0.0",
          },
        ],
  
      },
    ownersAndFinancials: {
      tableColumns: [
        {
          title: "Owner",
          dataIndex: "owner",
          width:'70%'
        },
        {
          title: "Percent Owned",
          dataIndex: "percentOwned",
        },
        {
          title: "Contract Expiration",
          dataIndex: "contractExpiration",
        },
      ],
      tableData: [
        {
          key: "1",
          owner: "Casa Rentals LLC",
          percentOwned: "200.0",
          contractExpiration: "--",
        },
      ],
      ownershipStartDate: "",
      paymentType: "Net Income",
      reserveFunds: "200.00",
      vendor1099Payer: "Use Portfolio (Integrity Oklahoma LLC)",
      fiscalYearEnd: "December",
      basisForOwnerPackets: "Cash",
    },
    managementFees: {
      startDate: "Oct 2022 ",
      endDate: "",
      waiveFeesWhenVacant: false,
      feeType: "Percent",
      amount: "",
      minimum: "",
      maximum: "",
      managementFee: "8.5%",
      whenVacant: "Collected",
    },
    additionalFees: {
      leaseFee: {
        LeaseFeeType: "Flat",
        LeaseFlatFee: "200.00",
      },
      renewalFee: {
        renewelFeeType: "Flat",
        renewalFlatFee: "100.00",
      },
      additionalFees: {
        tableColumns: [
          {
            title: "GL Account",
            dataIndex: "glAccount",
          },
          {
            title: "Percentage",
            dataIndex: "percentage",
          },
          {
            title: "Suppress",
            dataIndex: "suppress",
          },
        ],
        tableData: [
          {
            key: "1",
            glAccount: "112: Application Fee Income",
            percentage: "100.0",
            suppress: "Yes",
          },
          {
            key: "2",
            glAccount: "998: tbp	",
            percentage: "100.0",
            suppress: "Yes",
          },
          {
            key: "3",
            glAccount: "997: Eviction Notice Fee	",
            percentage: "100.0",
            suppress: "Yes",
          },
        ],
      },
    },
    lateFeePolicy: {
      baseAmount: "10.0%",
      eligibleCharges: "All",
      calculateFeeFrom: "New Delinquent Charge",
      ignorePartialPayments: "No",
      dailyAmountOrMonthlyMax: "",
      gracePeriod: "Late fees post after 3 days",
      graceBalance: "0.00",
    },
    keys: {
      tableColumns: [
        {
          title: "ID",
          dataIndex: "id",
        },
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Available",
          dataIndex: "available",
        },
        {
          title: "Check Out",
          dataIndex: "available",
          fixed: "right",
          render: () => <a>Check Out</a>,
        },
      ],
      tableData: [
        {
          id: "1",
          description: "test",
          available: "2/2",
        },
      ],
    },
    maintenanceInformation: {
      maintenanceLimit: "0.00",
      insuranceExpiration: "",
      isCoveredHomeWarranty: false,
      unitEntryPreAuthorized: false,
      maintenanceNotes: "",
      onlineMaintenanceRequestInstructions: "",
    },
   
    propertyGroups: "test group",
    statementSettings: {
      useEnhancedStatement: true,
      includeCurrentUpcomingCharges: true,
      includeUpcomingChargesInAmountDue: true,
      includeCustomMessage: false,
      includeLogo: false,
      includePaymentDueDate: false,
      chargerHistoryIncludes: "All Past Due Charges",
      includePaymentHistoryAndBalanceForward: false,
      isShowRemainingAmountDueForPastDue: false,
    },
    bankAccounts: {
      tableColumns: [
        {
          title: "Cash GL Account",
          dataIndex: "cashGLAccount",
        },
        {
          title: "Bank Account",
          dataIndex: "bankAccount",
          render:(_,record) => (
            <>
             <a href="#">{record.bankAccount[0]}</a>
             <br />
             <span>{record.bankAccount[1]}</span>
            </>
          )
        },
        {
          title: "Payments Enabled",
          dataIndex: "paymentsEnabled",
          render: (_,record) => <span className="paymentEnabledTag">{record.paymentsEnabled}</span>,
        },
      ],
      tableData: [
        {
          key: "1",
          cashGLAccount: "23291: Rental Income Account",
          bankAccount: [
            "Rental Income Account (Liberty National Bank)",
            "(Operating Cash Account)",
          ],
          paymentsEnabled: "ENABLED",
        }
        
      ],
    },
  },
];
